const AppointmentTypesEnum = Object.freeze({
  AUTOMATIC: 'automatic',
  PATIENT_CALL: 'patient_call',
  CHART_CHECK: 'chart_check',
  TECH_CALL: 'tech_call',
  ONSITE: 'onsite',
});

export default AppointmentTypesEnum;
